import { getMetaTag } from './get-meta-tag'

export function isMedianBridgeApp(){
  return getMetaTag(`median-app`) != null
}
